(function ($) {
  Drupal.behaviors.aerinBrandStylesV1 = {
    attached: false,
    attach: function () {
      if (this.attached) {
        return;
      }
      this.attached = true;

      $('body').addClass('brand-aerin');
    }
  };
})(jQuery);
